// Please maintain the sort order when adding to this list
export const ADD_ADMIN_BLOCK_BUTTONS = 'addAdminBlockButtons';
export const CHART_ELEMENT_V2 = 'chartElementV2';
export const CHART_ELEMENT_SAVE_ERROR_LOGGING = 'chartElementSaveErrorLogging';
/** Displays the Prescription Task MDT card to clinicians who can accept */
export const CL_CAN_ACCEPT_PRESCRIPTION_TASKS = 'clCanAcceptPrescriptionTasks';
export const CLINIC_ACTIONS_OVERRIDE = 'clinicActionsOverride';
export const CLINICAL_SNAPSHOT = 'clinicalSnapshot';
export const CLINICAL_SNAPSHOT_PROBLEMS_DATA = 'clinicalSnapshotProblemsData';
export const CLINICAL_SNAPSHOT_VISIT_DATA = 'clinicalSnapshotVisitData';
export const CLINICAL_SNAPSHOT_ZD_TICKETS_DATA = 'clinicalSnapshotZdTicketsData';
/* Display progress of completed visits in relation to visit limits */
export const COMPLETED_VISITS_PROGRESS = 'completedVisitsProgress';
export const COUNTERSIGN = 'countersign';
export const DISPLAY_PHARMACY_RECOMMENDATIONS = 'displayPharmacyRecommendations';
export const UPDATE_PHARMACY_RECOMMENDATIONS = 'updatePharmacyRecommendations';
export const DISPLAY_STRAIGHTFORWARD_REQUEST_ICON = 'displayStraightforwardRequestIcon';
/* Show UI elements for "air traffic control" users */
export const DROP_IN_ATC_INTERFACE = 'dropInQueueSettings';
export const DSP_HELP_BUTTON = 'dspHelpButton';
export const EDIT_DOSE_SPOT_MEDS_ON_DEBUG_PAGE = 'editDoseSpotMedsOnDebugPage';
export const FLOW_ACTIVE_ELEMENT_CONDITIONAL_OVERRIDE = 'flowActiveElementConditionalOverride';
export const HIDE_INQUIRIES = 'hideInquiries';
export const ID_VERIFICATION_DENIAL_NOTICE_UI = 'idVerificationDenialNoticeUI';
/** Enables auto-canceling clinical PIC visits and displaying new video status cards */
export const IS_AUTO_CANCELING_VISITS_ENABLED = 'isAutoCancelingVisitsEnabled';
export const MIGRATE_VISIT_CODES = 'migrateVisitCodes';
export const OBSERVABILITY_MY_DAY_TODAY = 'observabilityMyDayToday';
export const SHOW_MDT_SANDBOX = 'showMdtSandbox';
export const SHOW_OPTIONAL_SCHEDULE_TABLE = 'showOptionalScheduleTable';
export const PAYOR_BASED_WAITLIST_PROMOTION = 'payorBasedWaitlistPromotion';
/** Enables the pull-based PiC and My Day Today V2 layout */
export const POP_IN_V2 = 'popInV2';
export const PREVENT_DEPRECATED_EVENT_CREATION = 'preventDeprecatedEventCreation';
export const REFRESH_FLOW_ON_INTERACTION = 'refreshFlowOnInteraction';
export const REMOVE_LEGACY_CHAT_STAGE1_VIEW_ONLY = 'removeLegacyChatStage1ViewOnly';
export const REMOVE_LEGACY_CHAT_STAGE2_HIDE_DISPLAY = 'removeLegacyChatStage2HideDisplay';
export const RENDER_CHART_ELEMENT_MENU = 'renderChartElementMenu';
export const RENDER_PSS_BUTTONS = 'renderStaffAppPssButtons';
export const REQUEST_A_PEER = 'requestAPeer';
export const RESTRICT_QUEUE_PAGE_ACCESS = 'restrictQueuePageAccess';
export const PIC_ACCESS_FOR_ALL = 'picAccessForAll';
/** Displays an option in the event header to create a prescription task for an event */
export const RN_CAN_CREATE_PRESCRIPTION_TASKS = 'rnCanCreatePrescriptionTasks';
export const SHOW_ACCEPT_FOR_BUTTON = 'showAcceptForButton';
export const SHOW_BUSYNESS_DISPLAY = 'showBusynessDisplay';
/** Reveals the ID Verification table in the Patients' documents tab */
export const SHOW_ID_VERIFICATION_UI = 'showIdVerificationUI';
export const SHOW_POCT_RESULTS_V2 = 'showPoctResultsV2';
export const SHOW_SEE_A_PATIENT = 'showSeeAPatient';
export const SMS_COMMUNICATIONS = 'smsCommunications';
export const STAFF_APP_GOOGLE_ANALYTICS = 'staffAppGoogleAnalytics';
export const TURN_OFF_PEBBLES = 'turnOffPebbles';
export const UNOBSTRUCTED_CHART_ELEMENT_SAVE_ERROR = 'unobstructedChartElementSaveError';
export const UPDATED_MDT_INTAKE_CARD = 'updatedMdtIntakeCard';
export const USE_DATO_SHORTCUT_ENABLED_CHART_ELEMENTS = 'useDatoShortcutEnabledChartElements';
export const USE_LEGACY_VIDEO_CONFERENCE = 'useLegacyVideoConference';
/** Video (ORCA-309) */
export const VIDEO_END_DIALOG_V2 = 'videoEndDialogV2';
export const VIDEO_NAME_PROPERTY_UPDATE = 'videoNamePropertyUpdate';
export const ZENDESK_WEB_MESSENGER_DEBUGGING_TOOL = 'zenDeskWebWidgetDebuggingTool';
// Please maintain the sort order when adding to this list
